import classNames from 'classnames';

import styles from './index.module.scss';

export type StatusDotStatuses = 'online' | 'offline' | 'unknown';

export type StatusDotProps = {
  status?: StatusDotStatuses;
};

const statusDotColorStyle = {
  online: styles.statusDotOnline,
  offline: styles.statusDotOffline,
  unknown: styles.statusDotUnknown,
};

export const StatusDot = ({ status = 'unknown' }: StatusDotProps) => {
  return (
    <span
      className={classNames(styles.statusDot, statusDotColorStyle[status])}
    />
  );
};
